import { render, staticRenderFns } from "./GoodsMsdetail.vue?vue&type=template&id=d73630bc&"
import script from "./GoodsMsdetail.vue?vue&type=script&lang=js&"
export * from "./GoodsMsdetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports